import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Card, Container, Stack, TextField, Typography } from '@mui/material';

import { EntityContext } from '../entity';
import { maskPhone } from '../utils/phoneMask';

export default function SignerEditPage() {
  const { signerKey } = useParams();
  const navigate = useNavigate();
  const { getSigner, editSigner, loading } = useContext(EntityContext);

  const [signer, setSigner] = useState(null);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [pageError, setPageError] = useState('');

  useEffect(() => {
    getSigner(signerKey).then((data) => {
      if (data?.error) {
        setPageError(data.error.message);
        return;
      }
      setSigner(data);
      setPhone(maskPhone(data.phone_number));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signerKey]);

  const handleSave = async () => {
    setPhoneError('');
    setPageError('');
    const result = await editSigner(signerKey, phone);
    if (result?.error) {
      const fieldError = result.error.errors.find((e) => e.field === 'phone_number');
      if (fieldError) setPhoneError(fieldError.message);
      else setPageError(result.error.message);
      return;
    }
    navigate('/dashboard/signers');
  };

  return (
    <>
      <Helmet>
        <title> Editar assinante </title>
      </Helmet>

      <Container>
        <Typography variant="h4" gutterBottom>
          Editar assinante
        </Typography>

        <Card sx={{ p: 3 }}>
          <Stack spacing={2}>
            {signer ? (
              <>
                <Typography variant="h6">{signer.signer_name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {signer.signer_email}
                </Typography>
                <TextField
                  label="Celular do assinante"
                  type="tel"
                  placeholder="(11) 98765-4321"
                  value={phone}
                  error={Boolean(phoneError)}
                  helperText={phoneError || 'Deixe em branco para remover o celular.'}
                  onChange={(event) => setPhone(maskPhone(event.target.value))}
                />
              </>
            ) : null}

            {pageError ? <Alert severity="error">{pageError}</Alert> : null}

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button color="inherit" onClick={() => navigate('/dashboard/signers')}>
                Voltar
              </Button>
              {signer ? (
                <Button variant="contained" onClick={handleSave} disabled={loading}>
                  Salvar
                </Button>
              ) : null}
            </Stack>
          </Stack>
        </Card>
      </Container>
    </>
  );
}
